import type { FunctionComponent } from 'react'
import React from 'react'

import { MagnifierPlusIcon } from '../../../../../Icons/Navigational/MagnifierPlus'
import styles from './ZoomImageHint.module.scss'

export const ZoomImageHint: FunctionComponent = () => (
  <p className={styles.hint}>
    <MagnifierPlusIcon width={15} height={15} className={styles.hintIcon} />
  </p>
)
